import tw from "tailwind-styled-components";

export default tw.h1`
${(props) =>
  props.$loginTittle && "text-primary-title my-3 text-center text-4xl"}`;
